import React, { useContext, useLayoutEffect } from "react"

import { TabItemPropsType } from "../Tab.types"

import { TabContext } from "../context";

export const TabItem: React.FC<TabItemPropsType> = (props) => {
  const { activeKey, addItem } = useContext(TabContext)

  useLayoutEffect(() => {
    addItem(props.title, props.tabKey)
  }, [props.title, props.tabKey, addItem])

  // reactEmailEditor対策でdisplay none対応
  return <div style={props.tabKey === activeKey ? {} : {display: 'none'} }>{props.children}</div>
}